"use strict";

angular.module("customer")
.controller("InvoiceCopyController", function
    ($scope, $stateParams, UserService, InvoiceAttachmentService, UnauthenticatedInvoiceService
    ) {
    $scope.invoiceService = UnauthenticatedInvoiceService
    $scope.invoiceWithAttachment = InvoiceAttachmentService.getCopy($stateParams.id)
});



//////////////////
// WEBPACK FOOTER
// ./customer/sections/invoice-copy/invoice-copy.controller.js
// module id = 914
// module chunks = 0